import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import tracking from '@g4/g4-analytics';
import { Text, Box, VerticalSpacing } from '../../components/Boneyard';
import Markdown from '../../components/Markdown';
import PLANE_ICON_LEFT from '../../images/pattern-plane-path-top-left.svg';
import PLANE_ICON_RIGHT from '../../images/pattern-plane-path-top-right.svg';
import { NO_FLIGHTS_ERROR_PAGE } from '../../../automationHooks';

const ErrorBox = styled(Box)`
  text-align: center;
  margin: 0 auto;
  margin-top: 90px;
  min-height: 15em;
`;

const RightImg = styled.img`
  float: right;
  margin-bottom: 25px;
`;

const LeftImg = styled.img`
  float: left;
`;

const propTypes = {
  translations: PropTypes.object,
  searchCriteria: PropTypes.object,
};

const NoFlightsErrorMessage = ({ translations, searchCriteria }) => {
  const route = searchCriteria.destination + searchCriteria.origin;
  tracking.trackZeroSearchResults(route);
  return (
    <>
      <ErrorBox>
        <h2>
          <Text
            weight={600}
            size={24}
            automationHook={NO_FLIGHTS_ERROR_PAGE.hook}
          >
            {translations.missingFlightsErrorTitle}
          </Text>
        </h2>
        <VerticalSpacing size={4} />
        <Markdown source={translations.missingFlightsErrorMessage} />
        <VerticalSpacing size={10} />
      </ErrorBox>
      <RightImg src={PLANE_ICON_RIGHT} />
      <LeftImg src={PLANE_ICON_LEFT} />
    </>
  );
};

NoFlightsErrorMessage.propTypes = propTypes;
export default NoFlightsErrorMessage;
